export function isEnabled(value, defaultValue = false) {
  if (value === undefined || value === null || value.trim() === "") {
    return defaultValue;
  }
  return value.trim().toLowerCase() === "true";
}

export const features = Object.freeze({
  landingPage: isEnabled(process.env.REACT_APP_ENABLE_LANDING_PAGE),
  // Single flag gating the entire Time Tracking feature (badge, timer, manual
  // entries, reports). Defaults to enabled so existing deployments keep working
  // until REACT_APP_TIME_TRACKING_ENABLED=false is set.
  timeTracking: isEnabled(process.env.REACT_APP_TIME_TRACKING_ENABLED, true),
});
